import { atom } from "recoil";

export const bonusesAddModalStore = atom({
	key: "bonusesAddModalStore",
	default: {
		show: false,
		loaded: true,
		isPublic: true,
		advancedSettingsEnabled: false,
		type: false,
		count: "",
		uid: "",
		value: "",
		note: "",
		name: "",
		reason: null,
		reasonIdentifier: '',
		bonusCode: '',
		bonusAmount: '',
		bonusMode: 0,
		depositPercent: '',
		depositApplyLimit: '',
		minDeposit: '',
		maxDeposit: '',
		maxBonusAmount: '',
		bonusType: { label: 'All', value: 'all' },
		wager: null,
		showWagerConfirmation: false,
		maxWithdrawal: '',
		depositTo: '',
		depositFrom: '',
		depositCount: '',
		depositCountTo: '',
		depositCountDays: '',
		taskCount: '',
		taskDays: '',
		description: {},
		emailChecked: false,
		phoneChecked: false,
		tgChecked: false,
		verifiedChecked: false,
		otherPromoActivated: false,
		otherPromoAmount: '',
		otherPromoDateFrom: null,
		otherPromoDateTo: null,
		otherPromoDateType: '',
		activation_lifetime_days: '',
		promoDateFrom: null,
		promoDateTo: null,
		promoDateType: '',
		considerBetAmount: false,
		betAmount: '',
		betDateFrom: null,
		betDateTo: null,
		betDateType: '',
		trafficType: '',
		trafficSource: '',
		adCostTotal: '',
		adPayments: [],
		validityPeriod: null,
		vipLevelMode: null,
		vipLevel: null,
		lastDepositDateFrom: null,
		lastDepositDateTo: null,
		lastDepositDateType: "",
		playerIds: '',
		promoCountGeneration: 0,
		errors: {},
		checked: false,
	},
});
